/**
 * Upper bound of the ClickFind match-area range, in original-image px². Also
 * the "unbounded" sentinel: a configured max at/above this value means "no
 * upper limit" and disables max-area filtering. Used as the slider ceiling,
 * the schema default for `maxMatchAreaPx2`, and the runtime unbounded check.
 */
export const CLICKFIND_MAX_MATCH_AREA_PX2 = 50000;

/** A max-area config at/above the ceiling means "no upper limit". */
export function isUnboundedMaxMatchArea(maxAreaPx2: number): boolean {
  return maxAreaPx2 >= CLICKFIND_MAX_MATCH_AREA_PX2;
}
